import React from 'react';

import { Document, Page, Text, View } from '@react-pdf/renderer';

import TablePDF from './TablePDF';
import KeyValuePDF from '../shared/KeyValuePDF';
import GlosaryColorsPDF from '../shared/GlosaryColorsPDF';
import GlosaryAbreviationsPDF from '../shared/GlosaryAbreviationsPDF';
import DividerPDF from '../shared/DividerPDF';
import { getTablePDFStyle } from '../../constants';

// Create PDF Document component
/**
 * @typedef {Object} ReportData
 * @property {string} id - Unique identifier for the report item.
 * @property {Array<Object>} source - The data source for the table in the report.
 */

/**
 * @typedef {Object} KeyValueData
 * @property {string} label - The label for the key-value pair.
 * @property {string} value - The value for the key-value pair.
 */

/**
 * @typedef {Object} ReportPDFProps
 * @property {string} [title=''] - The title of the report.
 * @property {Array<ReportData>} [data=[]] - The data for the report.
 * @property {Array<KeyValueData>} [employeeData=[]] - The employee data to be displayed in the report.
 * @property {Array<KeyValueData>} [employerData=[]] - The employer data to be displayed in the report.
 * @property {Array<Object>} columns - The columns for the table in the report.
 */

const IncidentsReportTemplatePDF = ({ data = {}, orientation = 'portrait', title, includeGlosary = true }) => {
  const styles = getTablePDFStyle();
  const dataKeys = Object.keys(data);
  const cleanData = data[dataKeys[0]]

  return (
    <Document>
      <Page size="A4" orientation={orientation} style={styles.page}>
        <View height={410}>
          <View>
            <Text style={styles.title}>{title}</Text>
          </View>
          {includeGlosary && (
            <View>
              <View>
                <GlosaryAbreviationsPDF />
              </View>
              <View>
                <GlosaryColorsPDF />
              </View>
            </View>
          )}
   
          <View wrap={false} key={cleanData?.id} style={styles.cardReport}>
            <TablePDF
              headerSection={
                <View>
                  <View style={styles.infoHeader}>
                    {cleanData?.employee.map(({ label, value }) => (
                      <KeyValuePDF key={label} label={label} value={value} />
                    ))}
                  </View>

                  {!!cleanData?.employer.length && !!cleanData?.employee.length && <DividerPDF />}

                  <View style={styles.infoHeader}>
                    {cleanData?.employer.map(({ label, value }) => (
                      <KeyValuePDF key={label} label={label} value={value} />
                    ))}
                  </View>
                </View>
              }
              key={cleanData?.id}
              data={cleanData?.source}
              headers={cleanData?.columns}
            />
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default IncidentsReportTemplatePDF;
